import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import {
  HelpAssistantStatus,
  HelpChatRequest,
  HelpChatResponse,
  HelpOrderDraft,
  HelpOrderDraftResult,
  HelpPurchaseOrderDraft,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  private readonly httpService = inject(HttpService);

  status(): Observable<HelpAssistantStatus> {
    return this.httpService.get<HelpAssistantStatus>('TmsWeb/Help/Status');
  }

  chat(request: HelpChatRequest): Observable<HelpChatResponse> {
    return this.httpService.post<HelpChatResponse>('TmsWeb/Help/Chat', request);
  }

  createOrderDraft(draft: HelpOrderDraft): Observable<HelpOrderDraftResult> {
    return this.httpService.post<HelpOrderDraftResult>('TmsWeb/Help/CreateOrderDraft', draft);
  }

  createPurchaseOrderDraft(draft: HelpPurchaseOrderDraft): Observable<HelpOrderDraftResult> {
    return this.httpService.post<HelpOrderDraftResult>('TmsWeb/Help/CreatePurchaseOrderDraft', draft);
  }
}
